<template>
  <div>
    <vs-card>
      <ACard>
        <div class="flex justify-between">
          <a-button class="p-0" type="link" ghost icon="left" @click="$router.push('/task/lists')">Back to tasks lists</a-button>
        </div>
      </ACard>
    </vs-card>

    <vs-card>
      <ASpin :spinning="loading" :indicator="indicator">
        <ACard class="task-list-item" v-if="get_one_task_list">
          <div class="flex justify-between">
            <a-descriptions class="self-center">
              <a-descriptions-item label="Task list name">
                {{ get_one_task_list.title  || '-' }}
              </a-descriptions-item>
              <a-descriptions-item label="Description">
                {{ get_one_task_list.description }}
              </a-descriptions-item>
            </a-descriptions>
            <a-button type="primary" @click="openTaskTemp" style="border-radius: 3px !important;">Add task template</a-button>
          </div>
        </ACard>
      </ASpin>
    </vs-card>

    <vs-card class="mt-5">
      <XTable
        ref="taskTemplate"
        :model="model"
        @clickRow="editTaskTemplate"
        :options="{placeholder:'Search bill template',noContent: 'No bill template',is_row_selection: false,is_load_req: false}"
      >
          <span slot="action" slot-scope="text,record" class="flex space-x-3">
            <a-dropdown>
              <a-menu slot="overlay">
                <a-menu-item key="1" @click="editTaskTemplate(text.record)"> <a-icon type="edit" />Edit</a-menu-item>
                <a-menu-item key="2" @click="OpenDeleteTaskTemplate(text.record)"> <a-icon type="delete" />Delete</a-menu-item>
              </a-menu>
              <a-button style="margin-left: 8px" @click="is_click_add_time = false"> Actions <a-icon type="down" /> </a-button>
            </a-dropdown>
          </span>
          <span slot="assigned" slot-scope="text,record" class="flex space-x-3">
              <div v-if="text.record.assigned_user">
                {{ text.record.assigned_user.first_name }} {{ text.record.assigned_user.last_name }}
              </div>
          </span>
      </XTable>
      <a-modal title="New task template" :width="700" centered :visible="visible" @cancel="visible = false">
        <a-form :form="form" @submit.prevent="handleTaskTemplate">

          <div class="flex flex-col md:flex-row space-x-0 md:space-x-4">
            <div class="w-full md:w-3/5 flex-grow">
              <a-form-item label="Name" has-feedback>
                <a-input
                  v-decorator="['title',{ rules: [{ required: true, message: 'This field is required.' }] }]"
                  placeholder="Enter task name..."
                />
              </a-form-item>
            </div>
            <div class="w-full md:w-2/5">
              <a-form-item label="Priority" has-feedback>
                <a-select
                  style="width: 100%;border-radius: 3px !important;"
                  v-decorator="['priority',{ initialValue: 1,rules: [{ required: false, message: 'Please input your Task Name!' }] }]"
                >
                  <a-select-option :value="1">
                    Normal
                  </a-select-option>
                  <a-select-option :value="2">
                    High
                  </a-select-option>
                  <a-select-option :value="3">
                    Low
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>

          <a-form-item label="Description" has-feedback>
            <a-textarea
              v-decorator="['description']"
              :rows="10"
              placeholder="Enter description..."
            />
          </a-form-item>

          <div class="grid grid-cols-1 md:grid-cols-2 md:gap-4">
            <a-form-item label="Task type" has-feedback>
              <a-select
                placeholder="Find a task type"
                style="width: 100%"
                allowClear
                show-search
                :filter-option="filterOption"
                class="select"
                v-decorator="['task_type']"
              >
                <a-select-option v-for="task in task_types" :value="task.id">
                  {{ task.title }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <SelectOption url="/account/list/"
                          label="Assignee"
                          field="assigned_user"
                          :required="false"
                          method="get"
                          placeholder="Select an assignee"
                          class="w-full"
            />
          </div>

          <div id="task-footer">
            <a-divider/>
            <div class="flex space-x-2">
              <a-button type="primary"  style="border-radius: 3px" html-type="submit">Save tasks</a-button>
              <a-button type="primary" ghost style="border-radius: 3px" @click="visible = false">Cancel</a-button>
            </div>
          </div>

        </a-form>
      </a-modal>

      <deleteItem
        :url="`/task/task-template/${temp_row}/`"
        subject="Task template"
        :ele="$refs.taskTemplate"
        ref="taskDelete"
      />
    </vs-card>
  </div>

</template>

<script>
import XTable from '../../components/x-table/XTable'
import * as TableCol from './taskTemplate'
import mixin from  '../mixin/mixin'
import axios from '@/axios'
import deleteItem from '../communications/deleteItem'
import SelectOption from "../forms/SelectOptionSingle"

export default {
  name: "TaskTemplate",
  mixins:[mixin],
  components:{
    XTable,
    deleteItem,
    SelectOption
  },
  data(){
    return{
      model: null,
      visible: false,
      temp_row: false,
      loading : false,
      get_one_task_list: {},
      task_types: [],
      edit_mode: false,
      indicator : <a-icon type="loading" style="font-size: 24px" spin />
    }
  },
  methods:{
    OpenDeleteTaskTemplate(record){
      this.temp_row = record.id
      this.$refs.taskDelete.open = true
    },
    openTaskTemp(){
      this.visible = true
      if(this.edit_mode){
        this.form.resetFields()
      }
      this.edit_mode = false
    },
    editTaskTemplate(record){
      this.edit_mode = true
      this.temp_row = record.id
      if(this.is_click_add_time){
        this.visible = true
        this.$nextTick(()=>this.getTaskTemplate(record.id))
      }else
        this.is_click_add_time = true
    },
    async getTaskTemplate(id){
      try{
        this.$vs.loading()
        const { data } = await axios.get(`/task/task-template/${id}/`)
        data.task_type = data.task_type ? data.task_type.id : undefined
        data.task_list = data.task_list ? data.task_list.id : undefined
        data.assigned_user = data.assigned_user ? data.assigned_user.id : undefined
        this.form.setFieldsValue(data)
      }catch (e) {
        this.$message.error('Error receiving information')
      }finally {
        this.$vs.loading.close()
      }
    },
    handleTaskTemplate(){
      this.form.validateFields(async(err,values)=> {
        if (!err) {
          try{
            this.$vs.loading()
            values.task_list = this.get_one_task_list.id
            if(!values.assigned_user) values.assigned_user = null
            if(!values.task_type) values.task_type = null
            if(this.edit_mode){
              const id = this.temp_row
              await axios.put(`/task/task-template/${id}/`,values)
            }else
              await axios.post('/task/task-template/',values)
            this.visible = false
            this.form.resetFields()
            await this.$refs.taskTemplate.fetch()
            this.$notification['success']({
              message: 'Success',
              description: `Task template ${this.edit_mode ? 'updated' :'created'}.`,
            });
          }catch (e){
            this.visible = true
            this.$notification['error']({
              message: 'Error',
              description: `Task template failed.`,
            })
          }finally {
            this.$vs.loading.close()
          }
        }
      })
    },
    async getOneTaskList(){
      try{
        this.loading = true
        const { data } = await axios.get(`/task/task-list/${this.$route.params.id}/`)
        this.get_one_task_list = data
      }catch (e){
        this.$message.error('Error receiving information')
      }finally {
        this.loading = false
      }
    },
    async getTaskTypes(){
      const { data } = await axios.post('/task/task-type/query/',{ limit: 9999 })
      this.task_types = data.rows
    },
  },
  mounted() {
    this.$refs.taskTemplate.query.query = [{field:"task_list__id",value: this.$route.params.id, condition: "=" }]
    this.$refs.taskTemplate.fetch()
    this.is_click_add_time = true
    this.getOneTaskList()
    this.getTaskTypes()
  },
  created() {
    this.model = TableCol.default
  }
}
</script>

<style >
@import "../style/style.css";
.ant-btn-background-ghost.ant-btn-link,.ant-btn-link{
  color: #3A3DBE !important;
}
.task-list-item .ant-descriptions-item{
  padding-bottom: 0 !important;
}
</style>
